export const TEST_ID = 'lowGpaConcentrationWarning';

// Drone application threshold: 5 GPA or less.
export const DRONE_GPA_THRESHOLD = 5;

// Concentration threshold (% v/v) above which we warn at drone GPA.
export const CONCENTRATION_WARN_THRESHOLD_PCT = 3;

export const GPA_DECIMAL_PRECISION = 1;

export const CONCENTRATION_DECIMAL_PRECISION = 2;
